import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
export enum TariffsType {
  'summer'= 'summer',
  'winter' = 'winter'
}

@Component({
    selector: 'app-tariffs',
    templateUrl: './tariffs.component.html',
    styleUrls: ['./tariffs.component.scss'],
    standalone: false
})
export class TariffsComponent implements OnInit {
  summerPdf = '/assets/tariffs/Tarifblatt_BFMatrei_2026_Sommer.pdf';
  winterPdf = '/assets/tariffs/Tarifblatt_BFMatrei_2026.pdf';
  summerPdfSafeUrl: SafeResourceUrl;
  winterPdfSafeUrl: SafeResourceUrl;
  currentPdfSafeUrl: SafeResourceUrl;
  currentTariffType: TariffsType = TariffsType.summer;
  dialogVisible = false;
  tariffsType = TariffsType;

  constructor(private sanitizer: DomSanitizer) {
    this.summerPdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.summerPdf);
    this.winterPdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.winterPdf);
    this.currentPdfSafeUrl = this.summerPdfSafeUrl;
  }

  ngOnInit(): void {
  }

  downloadPDF(tariffType: TariffsType){
    const link = document.createElement('a');
    switch (tariffType){
      case TariffsType.summer:
        link.download = 'Tarifblatt_BFMatrei_2026_Sommer';
        link.href = this.summerPdf;
        link.click();
        break;
      case TariffsType.winter:
        link.download = 'Tarifblatt_BFMatrei_2026';
        link.href = this.winterPdf;
        link.click();
        break;
    }
  }

  showModal(tariffType: TariffsType) {
    if (window.innerWidth < 500 ){
      this.downloadPDF(tariffType);
    } else {
      this.currentTariffType = tariffType;
      this.currentPdfSafeUrl = tariffType === TariffsType.summer ? this.summerPdfSafeUrl : this.winterPdfSafeUrl;
      this.dialogVisible = true;
    }
  }

  closeModal() {
    this.dialogVisible = false;
  }
}
